import React from 'react';
import { IonAlert } from '@ionic/react';
import "./Alert.scss";

interface AlertProps {
  isOpen: boolean
  message: string
  backdropDismiss?: boolean
  title?: string
  dismiss?: any
  buttons: (any | string)[]
  mode: any
  cssClass?: string
  header?: string
}

export const Alert = ({ isOpen,
  message,
  backdropDismiss,
  title,
  dismiss,
  buttons,
  mode,
  cssClass }: AlertProps) => {
  return (
    <>
      <IonAlert
        data-testid="alert"
        isOpen={isOpen}
        message={message}
        backdropDismiss={backdropDismiss ? true : backdropDismiss}
        header={title}
        onDidDismiss={dismiss}
        buttons={buttons}
        mode={mode}
        cssClass={cssClass || ''}
      />
    </>
  )
}
